import Auth from '@aws-amplify/auth'

const state = {
    user: {},
    userId: null,
    attributes: []
}

// getters
const getters = {
    user: state => state.user,
    userId: state => state.userId,
    session: state => state.user ? state.user.signInUserSession : {},
    attributes: state => state.attributes
}

// actions
const actions = {
    fetchUser ({ commit }) {
        return new Promise((resolve, reject) => {
            Auth.currentAuthenticatedUser().then(user => {
                commit('setUser', { user })
                Auth.currentUserInfo().then(data => {
                    commit('setUserId', { userId: data.id })
                    commit('setAttributes', { attr: user.attributes })
                    resolve()
                }).catch(err => {
                    commit('setAttributes', { attr: {} })
                    commit('setUserId', { userId: null })
                    reject(err)
                })
            }).catch((err) => {
                commit('setUser', { user: {} })
                reject(err)
            })
        })
    }
}

// mutations
const mutations = {
    setUser (state, { user }) {
        state.user = user
    },
    setUserId (state, { userId }) {
        state.userId = userId
    },
    setAttributes (state, { attr }) {
        state.attributes = attr
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
